export default "__VITE_ASSET__DYposN9t__"